import React from "react";
import { observer } from "mobx-react";

const TYPE_ICONS = {
  person: "👤",
  company: "🏢",
  award: "🏆",
  event: "📅",
  platform: "💻",
  metric: "📊",
  other: "📌"
};

const KeyMentions = observer(({ mentions }) => {
  if (!mentions || mentions.length === 0) return null;

  return (
    <div className="drSection">
      <div className="drSectionHeader">
        <span className="drSectionIcon">🔑</span>
        <h3>Key Mentions</h3>
        <span className="drSectionCount">{mentions.length}</span>
      </div>
      <div className="drMentionsList">
        {mentions.map((mention, index) => {
          const icon = TYPE_ICONS[(mention.type || "other").toLowerCase()] || "📌";
          return (
            <div key={index} className="drMentionCard">
              <div className="drMentionHeader">
                <span>{icon}</span>
                <span className="drMentionValue">@{mention.value}</span>
                {mention.date && <span className="drMentionDate">{mention.date}</span>}
              </div>
              <p className="drMentionContext">{mention.context}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default KeyMentions;
